import React, { useMemo, useState } from "react";
import CumulativeProgressionChart, { buildDatasetSeries } from "../VoteCharts/CumulativeProgressionChart";
import { getTeamRoundsByDataset } from "./teamRoundVotes";

/**
 * Season progression for a team: one cumulative line per enabled dataset plus
 * the consensus average, so the spread shows how much the sources disagree on
 * the team's haul.
 */
const TeamVoteProgressionChart = ({ team, gameVoteData, enabledKeys = [], roster = null }) => {
  // enabledKeys and roster are rebuilt on every render, so key the memo on their
  // contents — scanning every dataset is too costly to redo on each hover.
  const enabledKey = enabledKeys.join(',');
  const rosterKey = roster ? roster.map((p) => p?.name).join('|') : '';

  const series = useMemo(
    () => buildDatasetSeries(getTeamRoundsByDataset(team, gameVoteData, enabledKeys, roster)),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [team, gameVoteData, enabledKey, rosterKey]
  );

  const [hoverSeries, setHoverSeries] = useState(null);

  if (!team || !gameVoteData || !series.length) return null;

  return (
    <div className="bg-slate-950/60 rounded-xl border border-slate-800 p-3 sm:p-4">
      <CumulativeProgressionChart
        series={series}
        consensusIndex={0}
        hoverSeries={hoverSeries}
        onHoverSeries={setHoverSeries}
        ariaLabel="Cumulative team votes by round, per dataset"
        // Team hauls run to ~90 votes, so cap the increments at 5 and give the
        // extra gridlines the vertical room they need.
        maxStep={5}
        height={280}
      />
    </div>
  );
};

export default TeamVoteProgressionChart;
